import {useAppContext, useUserContext} from "../index";
import {api} from "../../services";

// Here's where we fetch the product data when the user
// tries to add a product to cart outside the product page.
export const useBehavioralContextHelper = (props) => {
    // Destructured props
    const {
        sidebarCartData
    } = props;

    const {
        storeLocation,
        setFullPageLoader
    } = useAppContext();

    const [{}, {}, {acceptedTermUse}] = useUserContext();

    const productDataFetcher = async (dataSet) => {
        setFullPageLoader(true);

        try {
            // The actual API call
            let response =
                await api.get(`/v1/cms/view?url=${sidebarCartData.url || dataSet.url}&regionId=${storeLocation.id}`);

            // The data to be assigned to the sidebarCartData state
            const data = {
                isOpen:         false,
                newProductData: {
                    selectedAmount:             1,
                    productData:                response.data,
                    productCategoryServiceType: response.data["product"]?.categoryServiceType,
                },
                // Here we clear the URL property because it's no longer needed
                url:                            "",
            }

            // If the fetched product has the same warehouse as the last one added,
            // then it opens the same warehouse modal component.
            // Otherwise, it just follows as normal.
            if (response.data.variants.find(item => {
                // return item.id === sidebarCartData.lastWarehouseAdded.data.id;
                return item.name.toLowerCase().includes(
                    sidebarCartData.lastWarehouseAdded.data.label.toLowerCase()
                );
            }) && acceptedTermUse) {
                data.isSameWarehouseModalOpen = true;
            } else {
                data.isOpen = true;
            }

            // Returns the response data to the main cart state
            return data;
        } catch (e) {
            console.log("Error while fetching product data:", e);

            return {};
        } finally {
            setFullPageLoader(false);
        }
    }

    return {
        productDataFetcher
    }
}
